export const buildUrl = () => "http://localhost:8003/recommendation/";
